 document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".product-card").forEach(card => {
    const img = card.querySelector(".product-image");
    const link = card.querySelector(".product-image-link");
    const price = card.querySelector(".product-price");
    const swatches = card.querySelectorAll(".swatch");

    if (!swatches.length) return;
 
    const first = swatches[0];
    first.classList.add("active");
 
    swatches.forEach(btn => {
      btn.addEventListener("click", () => {
        swatches.forEach(s => s.classList.remove("active"));
        btn.classList.add("active");
        img.src = btn.dataset.image;
        link.href = btn.dataset.url;
        price.textContent = btn.dataset.price;
      });
    });
  });
});